import React from 'react';
import reactDom from '../../../common/react/dom/index';
import PromoContainer from '../../../components/frontend/promo';

export default function init() {
	reactDom(<PromoContainer />, 'js-react-promo');
}
